import { render, staticRenderFns } from "./CoursePackDetails.vue?vue&type=template&id=00d2c9d2&scoped=true"
import script from "./CoursePackDetails.vue?vue&type=script&lang=js"
export * from "./CoursePackDetails.vue?vue&type=script&lang=js"
import style0 from "./CoursePackDetails.vue?vue&type=style&index=0&id=00d2c9d2&prod&scoped=true&lang=css"
import style1 from "./CoursePackDetails.vue?vue&type=style&index=1&id=00d2c9d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d2c9d2",
  null
  
)

export default component.exports